<template>
  <div>
    <v-dialog
    v-model="dialog"
    max-width="800"
    >
      <v-card>
        <v-card-text class="pt-4">
          <v-icon class="float-right" @click="dialog = false" medium>mdi-close</v-icon>
          <h3>Nastavení {{title}}</h3>
        </v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-menu
                ref="portionsDateFrom"
                v-model="dateFromMenu"
                :close-on-content-click="false"
                :return-value="dateFrom"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="dateFrom"
                    label="Od"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dateFrom"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu
                ref="portionsDateTo"
                v-model="dateToMenu"
                :close-on-content-click="false"
                :return-value="dateTo"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateTo"
                    label="Do"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="dateTo" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                color="error"
                label="Uživatel"
                prepend-icon="mdi-format-list-bulleted"
                v-model="user"
                :items="users"
                item-text="fullName"
                return-object
                hide-selected
                persistent-hint
                deletable-chips
                small-chips
                outlined
              />
              <v-select
                color="error"
                label="Vyberte jídlo"
                prepend-icon="mdi-format-list-bulleted"
                v-model="meal"
                :items="meals"
                item-text="name"
                return-object
                hide-selected
                persistent-hint
                deletable-chips
                small-chips
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-card
      elevation="3"
      class="mx-auto">
      <v-row>
        <v-col>
          <v-card-text class="pt-1">
            <div class="title font-weight-light mb-2">{{title}}</div>
            <div class="subheading font-weight-light grey--text">{{dateSpan}}</div>
          </v-card-text>
        </v-col>
        <v-col class="text-right mr-7 mt-4">
          <v-icon @click="dialog = true" medium>mdi-cog</v-icon>
        </v-col>
      </v-row>
      <v-sheet
        class=" mx-auto"
      >
        <AdjustableGraph :title="title" :chart-data="chartData" v-if="loaded" />
      </v-sheet>
    </v-card>
  </div>
</template>

<script>
import AdjustableGraph from './AdjustableGraph'
export default {
  props: ['title', 'sourceUrl', 'users', 'meals'],
  name: 'AdjustableChart',
  components: { AdjustableGraph },
  data () {
    return {
      headers: [
        { text: 'Datum', value: 'date' },
        { text: 'Hodnota', value: 'value' }
      ],
      dialog: false,
      dateFrom: null,
      dateTo: new Date().toISOString().slice(0, 10),
      dateToMenu: false,
      dateFromMenu: false,
      dataAll: {},
      tableValues: [],
      chartData: {},
      user: null,
      meal: null,
      loaded: false
    }
  },
  computed: {
    dateSpan () {
      const to = new Date(this.dateTo)
      const from = new Date(this.dateFrom)
      if (to - from < 0) {
        return 'Chyba'
      }
      const diff = (to - from) / 86400000 + 1
      return `${diff} ${diff === 1 ? 'den' : diff >= 2 && diff <= 4 ? 'dny' : 'dnů'}`
    }
  },
  methods: {
    getData () {
      this.loaded = false
      this.$http.post(this.sourceUrl, this.keysToSnakeCase({
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        userId: this.user ? this.user.id : null,
        itemId: this.meal ? this.meal.id : null,
        type: this.meal ? this.meal.type : null
      }))
        .then(res => {
          this.tableValues = []
          this.dataAll = this.keysToCamelCase(res.data)
          this.chartData = {
            labels: Object.keys(res.data),
            datasets: [
              {
                label: this.title,
                data: Object.values(res.data),
                backgroundColor: 'rgba(1, 116, 188, 0.50)',
                borderColor: 'rgba(1, 116, 188, 0.50)',
                pointBackgroundColor: 'rgba(171, 71, 188, 1)'
              }
            ]
          }

          Object.keys(this.dataAll).forEach(date => {
            this.tableValues.push({
              date: date,
              value: this.dataAll[date]
            })
          })
          this.loaded = true
        })
    }
  },
  created () {
    const weekAgo = new Date()
    weekAgo.setDate(new Date().getDate() - 6)
    this.dateFrom = weekAgo.toISOString().slice(0, 10)
    this.getData()
  },
  watch: {
    dateTo () {
      this.getData()
    },
    dateFrom () {
      this.getData()
    },
    user () {
      this.getData()
    },
    meal () {
      this.getData()
    }
  }
}
</script>

<style scoped>

</style>
